import { render, staticRenderFns } from "./ThemeSelection.vue?vue&type=template&id=1b66930b&"
import script from "./ThemeSelection.vue?vue&type=script&lang=js&"
export * from "./ThemeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports